var _linearGradient, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKlaviyoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345 232.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 201.646,
    y1: 888.049,
    x2: 201.646,
    y2: 559.35,
    gradientTransform: "translate(29.678 -395.517) scale(.7071)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1c205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#93c94b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.486,
    stopColor: "#70c05a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#12b259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903,
    stopColor: "#24ad69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24ad69"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.974 105.249L161.436 2.924c6.091-3.898 15.592-3.898 21.683 0L337.58 105.249c9.258 6.09 9.258 16.08 0 22.17l-20.709 13.643c-30.454-47.995-84.052-79.667-144.716-79.667-60.908 0-114.263 31.916-144.716 79.667L6.73 127.418c-9.014-6.09-9.014-16.322.244-22.17zm165.182-1.218c-46.046 0-86.245 24.362-109.146 60.42l35.57 23.632c15.105-24.85 42.148-41.417 73.333-41.417 30.941 0 58.228 16.567 73.333 41.417l35.57-23.632c-22.172-36.057-62.614-60.42-108.66-60.42zm0 85.514c-16.08 0-30.21 9.015-37.763 22.17l23.876 15.593c3.898 3.167 8.527 5.116 13.887 5.116 5.36 0 10.233-1.95 13.887-5.116l23.876-15.592c-7.066-12.913-21.44-22.17-37.763-22.17z",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaviyoLogo);
export default __webpack_public_path__ + "static/media/klaviyo-logo.9cbe8ae32db9b5ed4c5ff323ff864872.svg";
export { ForwardRef as ReactComponent };